export const MORE_URL = 'https://yandex.ru/support2/rythm/ru/author/statistics';
